import { EmptySection } from './empty-section';

export class EmptySectionMatchesColorOfFollowingProductSection extends EmptySection {
  public backgroundColor: string;
}
